import React from 'react';
import { Route, Switch } from 'react-router-dom';

import InstallCustomerApp from './InstallCustomerApp';
import InstallEmployeeApp from './InstallEmployeeApp';
import WelcomeAdmin from './WelcomeAdmin';
import WelcomeCustomer from './WelcomeCustomer';
import WelcomeEmployee from './WelcomeEmployee';

export default function Welcome() {
  return (
    <Switch>
      <Route
        path="/welcome/customer-employee/:token"
        component={WelcomeEmployee}
      />
      <Route path="/welcome/customer-employee" component={InstallEmployeeApp} />

      <Route path="/welcome/customer/:token" component={WelcomeCustomer} />
      <Route path="/welcome/customer" component={InstallCustomerApp} />

      <Route path="/welcome/employee/:token" component={WelcomeEmployee} />
      <Route path="/welcome/employee" component={InstallEmployeeApp} />

      <Route path="/welcome/admin/:token" component={WelcomeAdmin} />
    </Switch>
  );
}
